import {
  ApiBlueprint,
  createFrontendPlugin,
  discoveryApiRef,
  fetchApiRef,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import { NavContentBlueprint } from '@backstage/plugin-app-react';
import { RiDashboardLine } from '@remixicon/react';
import { rootRouteRef } from './routes';
import { dashboardApiRef, DashboardClient } from './api';
import { DashboardSidebarItem } from './components/DashboardSidebarItem/DashboardSidebarItem';

const dashboardApi = ApiBlueprint.make({
  name: 'plugin.dashboard.api',
  params: defineParams =>
    defineParams({
      api: dashboardApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) =>
        new DashboardClient(discoveryApi, fetchApi),
    }),
});

const dashboardPage = PageBlueprint.make({
  params: {
    path: '/dashboard/:dashboardId',
    routeRef: rootRouteRef,
    noHeader: true,
    loader: () =>
      import('./components/DashboardPage/DashboardPage').then(m => (
        <m.DashboardPage />
      )),
  },
});

const dashboardNavItem = NavContentBlueprint.make({
  name: 'dashboard',
  disabled: false,
  params: {
    component: DashboardSidebarItem,
  },
});

export default createFrontendPlugin({
  pluginId: 'dashboard',
  title: 'Dashboard',
  icon: <RiDashboardLine />,  
  routes: {
    root: rootRouteRef,
  },
  extensions: [dashboardApi, dashboardPage, dashboardNavItem],
}) as any;

export { DashboardSidebarItem } from './components/DashboardSidebarItem/DashboardSidebarItem';